import axios from "axios";
import { post } from ".";

const tenant = process.env.REACT_APP_SSO_TENANT_ID;
const clientId = process.env.REACT_APP_SSO_CLIENT_ID;
const redirectUri = window.location.origin;

const baseURL = `https://login.microsoftonline.com/${tenant}`;

const oauth2Client = axios.create({
  baseURL: baseURL,
  timeout: 20000,
});

export const generateCodeVerifier = () => {
  const array = new Uint32Array(128);
  window.crypto.getRandomValues(array);
  return array.join("");
};

export const generateCodeChallenge = async (codeVerifier) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);
  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
};

// const codeVerifier = generateCodeVerifier();
const codeVerifier = "em2GjpX0WLgi7w40hs-jRd_B_TY5gv8HqnXQQ9BLj7w";
const codeChallenge = await generateCodeChallenge(codeVerifier);
// const codeChallenge = "mOsUeP9sozZ7WabUo2lbynEUN-PvUcO7JZpU4qANfIQ";

export const authorize = () => {
  const state = new Date().getTime();
  return `${baseURL}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&response_mode=query&scope=https://graph.microsoft.com/User.Read&state=${state}&code_challenge=${codeChallenge}&code_challenge_method=S256`;
};

export const getToken = async (code) => {
  const params = new URLSearchParams();
  params.append("client_id", clientId);
  params.append("grant_type", "authorization_code");
  params.append("code", code);
  params.append("redirect_uri", redirectUri);
  params.append("code_verifier", codeVerifier);
  params.append("scope", "https://graph.microsoft.com/User.Read");

  try {
    const response = await oauth2Client.post(`/oauth2/v2.0/token`, params.toString(), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const ssoLogin = async (token) => {
  return await post(`auth/token-sso`, undefined, { headers: { Authorization: `Bearer ${token}` } });
};

export const getUser = async (token) => {
  try {
    const headers = {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    };

    const response = await axios.get("https://graph.microsoft.com/v1.0/me", { headers });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
